import React from 'react';

const PrivacyPolicyPage = () => {
	return (
		<div className="container privacy-policy">
			<div className="section section-404 p-0 m-0 height-100vh">
				<div className="row">
					<div style={{ padding: '20px' }}>
						<h1>Privacy Policy</h1>
						<h2>Trash Joes</h2>
						<p><strong>74 Buffalo Inc DBA Trash Joes</strong></p>
						<p>
							<strong>Last updated:</strong> February 12, 2026
						</p>
						<p>This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
						<p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>

						<h2>Interpretation and Definitions</h2>
						<h3>Interpretation</h3>
						<p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

						<h3>Definitions</h3>
						<p>For the purposes of this Privacy Policy:</p>
						<ul>
							<li>
								<strong>Account:</strong> A unique account created for You to access our Service or parts of our Service.
							</li>
							<li>
								<strong>Affiliate:</strong> An entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest, or other securities entitled to vote for election of directors or other managing authority.
							</li>
							<li>
								<strong>Company:</strong> (referred to as either "the Company," "We," "Us," or "Our" in this Agreement) refers to 74 Buffalo Inc DBA Trash Joes, 1815 North Union, Fremont, NE 68025.
							</li>
							<li>
								<strong>Cookies:</strong> Small files that are placed on Your computer, mobile device, or any other device by a website, containing the details of Your browsing history on that website among its many uses.
							</li>
							<li>
								<strong>Country:</strong> Refers to the United States.
							</li>
							<li>
								<strong>Device:</strong> Any device that can access the Service, such as a computer, a cellphone, or a digital tablet.
							</li>
							<li>
								<strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual.
							</li>
							<li>
								<strong>Service:</strong> Refers to the Website and SMS text messaging services.
							</li>
							<li>
								<strong>Service Provider:</strong> Any natural or legal person who processes the data on behalf of the Company.
							</li>
							<li>
								<strong>Usage Data:</strong> Data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.
							</li>
							<li>
								<strong>Website:</strong> Refers to 74 Buffalo Inc DBA Trash Joes at <a href="http://www.trashjoes.com">www.trashjoes.com</a>.
							</li>
							<li>
								<strong>You:</strong> The individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
							</li>
						</ul>

						<h2>Collecting and Using Your Personal Data</h2>
						<h3>Types of Data Collected</h3>
						<h4>Personal Data</h4>
						<p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
						<ul>
							<li>Email address</li>
							<li>First name and last name</li>
							<li>Phone number (including mobile phone number for SMS services)</li>
							<li>Address, State, Province, ZIP/Postal code, City</li>
						</ul>

						<h4>Usage Data</h4>
						<p>Usage Data is collected automatically when using the Service.</p>
						<p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers, and other diagnostic data.</p>

						<h4>Tracking Technologies and Cookies</h4>
						<p>We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information.</p>
						<p><strong>Cookies and Website Analytics:</strong> We use information gained through cookies to compile statistical information about use of our Website, such as the time users spend at the site and the pages they visit most often. Those statistics do not include Personal Data.</p>
						<p>The technologies We use may include:</p>
						<ul>
							<li>
								<strong>Cookies or Browser Cookies:</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service.
							</li>
							<li>
								<strong>Web Beacons:</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons that permit the Company to count users who have visited those pages or opened an email.
							</li>
						</ul>

						<h3>Third-Party Tracking and Analytics Services</h3>
						<h4>Google Analytics</h4>
						<p>We use Google Analytics, a web analytics service provided by Google LLC. Google Analytics uses cookies to help us analyze how users use our Website. The information generated by the cookie about your use of the Website (including your IP address) will be transmitted to and stored by Google on servers in the United States.</p>
						<p>For more information on how Google uses data, please visit: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>

						<h4>Meta Pixel (Facebook Pixel)</h4>
						<p>We use Meta Pixel, an analytics and advertising tool provided by Meta Platforms, Inc. The Meta Pixel is code that we place on our Website to collect data that helps us track conversions from Facebook ads, optimize ads, build targeted audiences for future ads, and remarket to people who have already taken some action on our Website.</p>
						<p>The Meta Pixel collects data such as:</p>
						<ul>
							<li>Pages visited on our Website</li>
							<li>Actions taken on our Website (such as button clicks, form submissions)</li>
							<li>Device and browser information</li>
							<li>IP addresses</li>
						</ul>
						<p>This information is transmitted to Meta's servers, which may be located in the United States and other countries. For more information about Meta's privacy practices, please visit: <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a></p>

						<h4>Your Choices Regarding Tracking</h4>
						<p>You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this Website may become inaccessible or not function properly.</p>

						<h3>Use of Your Personal Data</h3>
						<p>The Company may use Personal Data for the following purposes:</p>
						<ul>
							<li>To provide and maintain our Service, including to monitor the usage of our Service.</li>
							<li>To manage Your Account: to manage Your registration as a user of the Service.</li>
							<li>For the performance of a contract: the development, compliance, and undertaking of the purchase contract for the products, items, or services You have purchased.</li>
							<li>To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication.</li>
							<li>To provide You with news, special offers, and general information about other goods, services, and events which we offer.</li>
							<li>To manage Your requests: To attend and manage Your requests to Us.</li>
							<li>For business analytics: To understand how our Website is being used and to improve our services.</li>
							<li>For advertising purposes: To show you targeted advertisements based on your interests and website activity.</li>
						</ul>

						<h2>SMS/Text Messaging Services</h2>
						<h3>SMS Program Overview</h3>
						<p>Trash Joes offers text messaging services to provide you with service updates, appointment reminders, promotional offers, and other waste management-related communications.</p>

						<h3>Consent to Receive Text Messages</h3>
						<p>By providing your mobile phone number and opting in to receive text messages from Trash Joes, you expressly consent to receive recurring automated marketing and service-related text messages (e.g., appointment reminders, service updates, promotional offers) from us at the phone number provided. Consent is not a condition of purchase of any goods or services.</p>

						<h3>SMS Data Collection and Use</h3>
						<p>When you opt in to our SMS program, we collect:</p>
						<ul>
							<li>Your mobile phone number</li>
							<li>Your name (if provided)</li>
						</ul>
						<p>We use this information solely for the purpose of sending you text messages related to our waste management services, including:</p>
						<ul>
							<li>Service appointment reminders</li>
							<li>Billing notifications</li>
							<li>Service alerts and updates</li>
							<li>Promotional offers and special deals</li>
							<li>Customer service communications</li>
						</ul>

						<h3>Message Frequency and Costs</h3>
						<p>Message frequency varies depending on your service and interaction with us. Message and data rates may apply. Check with your mobile carrier for details about your messaging plan.</p>

						<h3>Time Restrictions</h3>
						<p>Messages will only be sent between 8:00 AM and 9:00 PM in your local time zone, in compliance with federal regulations.</p>

						<h3>How to Opt Out of SMS Messages</h3>
						<p>You can opt-out of receiving text messages at any time by:</p>
						<ul>
							<li>Replying STOP to any text message from us</li>
							<li>Emailing us at <a href="mailto:nate@trashjoes.com">nate@trashjoes.com</a></li>
							<li>Calling us at 912-800-7474</li>
						</ul>
						<p>After texting STOP, you will receive one final confirmation message. You may continue to receive messages for a short period while we process your request.</p>

						<h3>How to Opt Back In</h3>
						<p>If you have opted out and wish to opt back in, reply START or UNSTOP to any previous message, or contact us using the contact information below.</p>

						<h3>SMS Help and Support</h3>
						<p>For assistance with our SMS program, reply HELP to any message or contact us at:</p>
						<ul>
							<li>Email: <a href="mailto:nate@trashjoes.com">nate@trashjoes.com</a></li>
							<li>Phone: 912-800-7474</li>
						</ul>

						<h3>SMS Supported Carriers</h3>
						<p>Our SMS service is available on all major U.S. carriers including AT&T, Verizon, T-Mobile, Sprint, and other participating carriers. Service may not be available on all carriers.</p>

						<h3>SMS Message Delivery and Liability</h3>
						<p>Trash Joes is not responsible for delays, failures in delivery, or any other issues related to the transmission or receipt of text messages. Message delivery is subject to effective transmission by your mobile carrier and is not guaranteed. By subscribing to our SMS services, you acknowledge that Trash Joes will not be liable for any damages, losses, or injuries arising from the use of or failure to receive text messages.</p>

						<h2>Sharing of Your Personal Data</h2>
						<p>We do not sell, rent, or trade your personal information to third parties for their marketing purposes.</p>
						<p><strong>Critical Privacy Protection for SMS Data:</strong> No mobile phone number information will be shared with third parties or affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</p>
						<p>We may share Your personal information only in the following limited circumstances:</p>
						<ul>
							<li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to provide our SMS messaging services, to process analytics data (Google Analytics), to provide advertising services (Meta/Facebook), and to contact You. These service providers are contractually obligated to use your information only for the purposes of providing services to us.</li>
							<li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with any merger, sale of Company assets, financing, or acquisition.</li>
							<li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy.</li>
							<li><strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.</li>
							<li><strong>As required by law:</strong> We may disclose your information where we are legally required to do so.</li>
						</ul>
						<p><strong>Important Note on Data Transfers:</strong> Some of our service providers (including Google Analytics and Meta/Facebook) may transfer and process your data in the United States and other countries. By using our Service, you consent to such transfers. We work with providers who maintain appropriate data protection measures.</p>

						<h2>Retention of Your Personal Data</h2>
						<p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.</p>

						<h2>Security of Your Personal Data</h2>
						<p>The security of Your Personal Data is important to Us. We use industry-standard security measures to protect your data from unauthorized access, including encryption and secure storage measures. However, remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure.</p>

						<h2>Children's Privacy</h2>
						<p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.</p>

						<h2>Links to Other Websites</h2>
						<p>Our Service may contain links to other websites that are not operated by Us. We strongly advise You to review the Privacy Policy of every site You visit. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

						<h2>Changes to this Privacy Policy</h2>
						<p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. We will let You know via email and/or a prominent notice on Our Service, and for SMS subscribers via text message, prior to the change becoming effective.</p>

						<h2>Contact Us</h2>
						<p>If you have any questions about this Privacy Policy, our SMS program, or our use of tracking technologies, You can contact us:</p>
						<ul>
							<li>Email: <a href="mailto:nate@trashjoes.com">nate@trashjoes.com</a></li>
							<li>Phone: 912-800-7474</li>
							<li>Address: 1815 North Union, Fremont, NE 68025</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrivacyPolicyPage;

